var re = new RegExp(['^', '\\[(\\$.+)\\]', '\\s', '([\\s\\S]+)', '$'].join(''));
export function angularMessageFilter(notice) {
  var err = notice.errors[0];
  if (err.type !== '' && err.type !== 'Error') {
    return notice;
  }
  var m = err.message.match(re);
  if (m !== null) {
    err.type = m[1];
    err.message = m[2];
  }
  return notice;
}